/* eslint-disable import/no-useless-path-segments */
/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
// import FileBase64 from 'react-file-base64';
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

import PropTypes, { object } from 'prop-types';
import clsx from 'clsx'
import moment from 'moment';
import { Modal, Dialog, DialogTitle, DialogContent, DialogActions, Box, TextField, Grid, FormGroup, IconButton } from '@material-ui/core'; // Remove the unused imports for CHG0073013
import DeleteIcon from '@mui/icons-material/Delete';
import { MdReplay } from 'react-icons/md';
import TablePagination from "@mui/material/TablePagination";
import { useHistory } from "react-router-dom";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import styles from './SpocForm.module.css'
import { CustomDatePicker, CustomFormGroup, CustomSelect, ValidatingTextField } from '../FormComponents'
import { DATE_FORMAT, API_RESOURCE_URLS, DISPLAY_MESSAGES, MESSAGE_TYPE, RESOURCE_TYPE, USER_OPERATIONS, Regex } from '../../constants'
import { API } from '../../apis/api'
import { buildErrorMessage } from '../../apis/calls'
import Table from '../Table/Table';
import Truckloading from "../../components/CvLoader/Cvloader";
import WarningModal from "../../components/WarningModal/WarningModal";
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { AuthChecker, Button } from '../../atomicComponents';
import { withAllowedOperationsProvider } from '../../hocs'
import { setLogin } from '../../redux/features/auth/actions';
import ReportTable from '../ReportTableComponent/ReportTable';
import { sanitizeNumeric } from '../../utils/utils';

function SpocForm() {
const auth = useSelector((state) => state.auth); // useSelector
const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
const { showPopup } = usePopupManager();

const history = useHistory();
  const ROW_HEIGHT = 38;
  const dispatch= useDispatch();
  const [rowsData, setRowsData] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });
 
  let {
    userName,
    personNumber,
    companyCode,
    userRole,
    } = auth;
    let UserRoles = userRole;
        let MangerFlag = UserRoles.includes("M");
    let DSFlag = UserRoles.includes("DS");
    let SUFlag = UserRoles.includes("S");
    let IndFlag = UserRoles.includes("U");
    let SAFlag = UserRoles.includes("SA");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmModalFlag2, setConfirmModal2] = useState(false);
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] = useState(false);
  let requiredUsers= ["M", "DS", "S", "U","SA"];
  const userList = userRole.filter(role => requiredUsers.includes(role));
  const [hover, setHover] = useState({ isHover: false, name: null });
  const [bodyBuilderOption, setBdybuilderOption] = useState([]);
  const [chassisOption, setChassisData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [asnCount, setAsnCount] = useState(0);
  const [tableArray, setTableArray] = useState([]);
  const [allTableData,setAllTableData]=useState([]);
  const [companyCodeOption, setCompanyCode] = useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [myState, setState] = React.useState(
    {
      checkFlag: false,
      UserRole: null,

    });

  /* SPOC Form States */

  const [ticketNo, setTicketNo] = useState("");
  const [bcName, setBcName] = useState("");
  const [bu, setBu] = useState("");
  const [barrel, setBarrel] = useState("")
  const [projDescp, setProjDescp] = useState("")
  const [loading, setLoading] = React.useState(false);
  const [viewDisplay, setViewDisplay] = useState(false);

  const HEIGHT = '';
  const FILENAME = 'SPOC_Report';
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  useEffect(() => {
    let userData = userList;
    setViewDisplay(true);
    setRowsPerPage(10)
    setPage(0)
  
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    if (userData =="SA") {
      setLoading(true);
      fetch(`${baseUrl}reports/SpocReportSA`, {
        method: "GET",
        credentials:'include',
        headers: headerss,
        // body: apiFormatedDataJson,
      })
      
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoading(false);
        }
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson.msg=="Success" && responseJson.data.length != 0) {
          setLoading(false);
          setState((prevState) => ({ ...prevState, tableFlag: true }));
          const finalList = [];
          responseJson.data.map((row, index) => {
            finalList.push({
              id: index,
              ...row,
            });
          });
          setAllTableData(finalList)
          setTableArray(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
        
        }
        else if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found",
        })
        setAllTableData([])
        }
        else if(responseJson && responseJson.msg=="Fail")  {
          setLoading(false);
          setAllTableData([])
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: responseJson.data,
        })
        } 
        setState((prevState) => ({ ...prevState, tableFlag: true }));
      }).catch((error) => {
        setLoading(false);
        setAllTableData([])
        if (error.response) {
          showPopup({
                  type: MESSAGE_TYPE.FAILURE,
                  contextText: MESSAGE_TYPE.FAILURE,
                  info: "Oops! Something went wrong. Please try again later. Please try again later",
              })
        }
        else {
          showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "There might be Network issue, please try after some time",
            })
        }
      });

    }
    else if (userData =="DS") {
      setLoading(true);
            let apiFormatedData = {
        "pers_no": sanitizeNumeric(personNumber)
      };
      let apiFormatedDataJson = JSON.stringify(apiFormatedData);

      fetch(`${baseUrl}reports/SpocReportDeptSpoc`, {
        method: "POST",
        headers: headerss,
        credentials:'include',
        body: apiFormatedDataJson,
      })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoading(false);
        }
        return response.json();
        })
      .then((responseJson) => {
        if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found",
        })
        setAllTableData([])
        }
        if (responseJson && responseJson.data.length != 0) {
          setState((prevState) => ({ ...prevState, tableFlag: true }));
          const finalList = [];
          responseJson.data.map((row, index) => {
            finalList.push({
              id: index,
              ...row,
            });
          });
          setAllTableData(finalList)
          setTableArray(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
          setLoading(false);
        } 
        else if(responseJson && responseJson.msg=="Fail")  {
          setLoading(false);
          setAllTableData([])
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: responseJson.data,
        })
        }
        setState((prevState) => ({ ...prevState, tableFlag: true }));
      }).catch((error) => {
        setAllTableData([])
        setLoading(false);
        if (error instanceof TypeError) {
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "There might be Network issue, please try after some time",
        })
        } else {
          // Handle HTTP errors
          console.error('HTTP Error:', error);
          if (error.response) {
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "Oops! Something went wrong. Please try again later",
          })
          }
        }
      });

    }

    else if (userData =="M") { 
      setLoading(true);
      
      let apiFormatedData = {
        "pers_no": sanitizeNumeric(personNumber)
      };
    let apiFormatedDataJson = JSON.stringify(apiFormatedData);
    fetch(`${baseUrl}reports/SpocReportManager`, {
      method: "POST",
      headers: headerss,
      credentials:'include',
      body: apiFormatedDataJson,
    })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoading(false);
        }
        return response.json();
        })
      .then((responseJson) => {
        if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found",
        })
        setAllTableData([])
        }
        if (responseJson && responseJson.data.length != 0) {
          setState((prevState) => ({ ...prevState, tableFlag: true }));
          const finalList = [];
          responseJson.data.map((row, index) => {
            finalList.push({
              id: index,
              ...row,
            });
          });
          setAllTableData(finalList)
          setTableArray(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
          setLoading(false);
        } 
        else if(responseJson && responseJson.msg=="Fail")  {
          setLoading(false);
          setAllTableData([])
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: responseJson.data,
        })
        }
        setState((prevState) => ({ ...prevState, tableFlag: true }));
      })
      .catch((error) => {
        setAllTableData([])
        setLoading(false)
        if (error instanceof TypeError) {
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "There might be Network issue, please try after some time",
        })
        } else {
          // Handle HTTP errors
          console.error('HTTP Error:', error);
          if (error.response) {
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "Oops! Something went wrong. Please try again later",
          })
          }
        }
      });
    }
    else if(userData =="U" || userData =="S"){
      setLoading(true);
      let apiFormatedData = {
        "pers_no": sanitizeNumeric(personNumber)
        };
    let apiFormatedDataJson = JSON.stringify(apiFormatedData);
    fetch(`${baseUrl}reports/SpocReportIndividual`, {
      method: "POST",
      headers: headerss,
      credentials:'include',
      body: apiFormatedDataJson,
    })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoading(false);
        }
        return response.json();
        })
      .then((responseJson) => {
        if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found",
        })
        setAllTableData([])
        }
        if (responseJson && responseJson.data.length != 0) {
          setState((prevState) => ({ ...prevState, tableFlag: true }));
          const finalList = [];
          responseJson.data.map((row, index) => {
            finalList.push({
              id: index,
              ...row,
            });
          });
          setAllTableData(finalList)
          setTableArray(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
          setLoading(false);
        } 
        else if(responseJson && responseJson.msg=="Fail")  {
          setLoading(false);
          setAllTableData([])
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: responseJson.data,
        })
        }
        setState((prevState) => ({ ...prevState, tableFlag: true }));
      })
      .catch((error) => {
        setAllTableData([])
        setLoading(false)
        if (error instanceof TypeError) {
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "There might be Network issue, please try after some time",
        })
        } else {
          // Handle HTTP errors
          console.error('HTTP Error:', error);
          if (error.response) {
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "Oops! Something went wrong. Please try again later",
          })
          }
        }
      });
    }
  }, []);

  useEffect(() => {
    setViewDisplay(true);
  }, []);
 
  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false
  });
  const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } = backgroundColors;

  const changeBackgroundColor = (field) =>
    setBackgroundColors(prev => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field)
          newBackgroundColors[key] = true;
        else
          newBackgroundColors[key] = false;
      }
      return newBackgroundColors
    })

  const handleOpen = () => setIsPopupOpen(true);
  const handleClose = () => setIsPopupOpen(false);

  const resetFields = () => {
  
    setBcName(null);
    setBu(null);
    setBarrel(null);
    setProjDescp(null);

  }

  const handleUserRoleDetails= (e) => {
   let userData = e;
    // console.log(e,'e');
    setState((prevState) => ({ ...prevState, UserRole:e}));
    setViewDisplay(true);
    setRowsPerPage(10)
    setPage(0)
    setLoading(true);
    let headerss = new Headers();
    const token = sessionStorage.getItem('token') 
    const sessionId = sessionStorage.getItem('sessionId')
    headerss.append('X-Session-Id', sessionId)
    headerss.append("authorization", `Bearer ${token}`);
    headerss.append("Content-Type", "application/json");

    if (userData =="SA") {
      fetch(`${baseUrl}reports/SpocReportSA`, {
        method: "GET",
        headers: headerss,
        credentials:'include',
        // body: apiFormatedDataJson,
      })
      .then((response) => {
       
        dispatch(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoading(false);
        }
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson.msg=="Success" && responseJson.data.length != 0) {
          setState((prevState) => ({ ...prevState, tableFlag: true }));
          const finalList = [];
          responseJson.data.map((row, index) => {
            finalList.push({
              id: index,
              ...row,
            });
          });
          setAllTableData(finalList)
          setTableArray(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
          setLoading(false);
        } 
        else if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found",
        })
        setAllTableData([])
        }
        else if(responseJson && responseJson.msg=="Fail")  {
          setLoading(false);
          setAllTableData([])

          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: responseJson.data,
        })
        } 
        setState((prevState) => ({ ...prevState, tableFlag: true }));
      }).catch((error) => {
        setLoading(false);
        setAllTableData([])
        if (error instanceof TypeError) {
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "There might be Network issue, please try after some time",
        })
        } else {
          // Handle HTTP errors
          console.error('HTTP Error:', error);
          if (error.response) {
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "Oops! Something went wrong. Please try again later",
          })
          }
        }
      });

    }

    else if (userData =="DS") {
      let apiFormatedData = {
        "pers_no": sanitizeNumeric(personNumber)
      };
    let apiFormatedDataJson = JSON.stringify(apiFormatedData);
      fetch(`${baseUrl}reports/SpocReportDeptSpoc`, {
        method: "POST",
        headers: headerss,
        credentials:'include',
        body: apiFormatedDataJson,
      })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoading(false);
        }
        return response.json();
        })
      .then((responseJson) => {
        // console.log(responseJson.data,"responseJson.data");
        if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found",
        })
        setAllTableData([])
        }
        if (responseJson && responseJson.data.length != 0) {
          setState((prevState) => ({ ...prevState, tableFlag: true }));
          const finalList = [];
          responseJson.data.map((row, index) => {
            finalList.push({
              id: index,
              ...row,
            });
          });
          setAllTableData(finalList)
          setTableArray(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
          setLoading(false);
        } 
        else if(responseJson && responseJson.msg=="Fail")  {
          setLoading(false);
          setAllTableData([])
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: responseJson.data,
        })
        }
       
        setState((prevState) => ({ ...prevState, tableFlag: true }));
      }).catch((error) => {
        setLoading(false);
        setAllTableData([])
        if (error instanceof TypeError) {
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "There might be Network issue, please try after some time",
        })
        } else {
          // Handle HTTP errors
          console.error('HTTP Error:', error);
          if (error.response) {
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "Oops! Something went wrong. Please try again later",
          })
          }
        }
      });

    }
    else if (userData =="M") { 
      
      let apiFormatedData = {
        "pers_no": sanitizeNumeric(personNumber)
      };
    let apiFormatedDataJson = JSON.stringify(apiFormatedData);  
    fetch(`${baseUrl}reports/SpocReportManager`, {
      method: "POST",
      headers: headerss,
      credentials:'include',
      body: apiFormatedDataJson,
    })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoading(false);
        }
        return response.json();
        })
      .then((responseJson) => {
        if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found",
        })
        setAllTableData([])
        }
        if (responseJson && responseJson.data.length != 0) {
          setState((prevState) => ({ ...prevState, tableFlag: true }));
          const finalList = [];
          responseJson.data.map((row, index) => {
            finalList.push({
              id: index,
              ...row,
            });
          });
          setAllTableData(finalList)
          setTableArray(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
          setLoading(false);
        }
        else if(responseJson && responseJson.msg=="Fail")  {
          setLoading(false);
          setAllTableData([])
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: responseJson.data,
        })
        }
        setState((prevState) => ({ ...prevState, tableFlag: true }));
      })
      .catch((error) => {
        setLoading(false);
        setAllTableData([])
        if (error instanceof TypeError) {
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "There might be Network issue, please try after some time",
        })
        } else {
          // Handle HTTP errors
          console.error('HTTP Error:', error);
          if (error.response) {
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "Oops! Something went wrong. Please try again later",
          })
          }
        }
      });
    }
    else if(userData =="U" || userData =="S"){
      let apiFormatedData = {
        "pers_no": sanitizeNumeric(personNumber)
        };
    let apiFormatedDataJson = JSON.stringify(apiFormatedData);
    fetch(`${baseUrl}reports/SpocReportIndividual`, {
      method: "POST",
      headers: headerss,
      credentials:'include',
      body: apiFormatedDataJson,
    })
      .then((response) => {
        dispatch(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoading(false);
        }
        return response.json();
        })
      .then((responseJson) => {
        if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found",
        })
        setAllTableData([])
        }
        // console.log(responseJson.data,"responseJson.data");
        if (responseJson && responseJson.data.length != 0) {
          setState((prevState) => ({ ...prevState, tableFlag: true }));
          const finalList = [];
          responseJson.data.map((row, index) => {
            finalList.push({
              id: index,
              ...row,
            });
          });
          setAllTableData(finalList)
          setTableArray(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
          setLoading(false);
        } 
        else if(responseJson && responseJson.msg=="Fail")  {
          setLoading(false);
          setAllTableData([])
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: responseJson.data,
        })
        }
        setState((prevState) => ({ ...prevState, tableFlag: true }));
      })
      .catch((error) => {
        setLoading(false);
        setAllTableData([])
        if (error instanceof TypeError) {
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "There might be Network issue, please try after some time",
        })
        } else {
          // Handle HTTP errors
          console.error('HTTP Error:', error);
          if (error.response) {
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: "Oops! Something went wrong. Please try again later",
          })
          }
        }
      });
    }
  }
    
  

  const baseDefaultColumns = [
    {
      width: 100,
      title: 'BC No',
      field: 'cost_center',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 190,
      title: 'BC Name',
      field: 'bc_name',
      enableSearch: true,
      enableFilter: true,
    },
    
    
    {
      width: 80,
      title: 'Barrel',
      field: 'barrel',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 90,
      title: 'Project No',
      field: 'project_def',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 220,
      title: 'Project Description',
      field: 'project_desc',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 90,
      title: 'Person No',
      field: 'pers_no',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 160,
      title: 'Person Name',
      field: 'complete_name',
      enableSearch: true,
      enableFilter: true,
    },

  ];

  const newKeySequence = [
    'id',
  'cost_center',
   'bc_name',
   'barrel',
  'project_def',
   'project_desc',
   'pers_no',
   'complete_name',
];

  function changeKeySequence(data, keySequence) {
    console.log(data);
    return data.map((dict) => {
      const newDict = {};
      keySequence.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(dict, key)) {
          newDict[key] = dict[key];
        }
      });
      return newDict;
    });
  }
  

  function downloadExcel(data) {
    const modifiedList = changeKeySequence(data, newKeySequence);
    console.log(modifiedList);

  const columnsKeys = {
        'id': 'Id',
        'cost_center':'BC No',
         'bc_name':'BC Name',
         'barrel':'Barrel',
        'project_def':'Project No',
         'project_desc':'Project Description',
         'pers_no':'Person No',
         'complete_name':'Person Name',
        }
    modifiedList.forEach((item, index) => {item.id = index + 1;});
    const updateExportData = modifiedList.map(dict => Object.keys(dict).reduce((acc, key) => {
      acc[columnsKeys[key] || key] = dict[key];
      return acc;
    }, {}));
    console.log(updateExportData,'updateExportData');
    const sheet = XLSX.utils.json_to_sheet(updateExportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, 'Sheet1');
    XLSX.writeFile(workbook, 'SPOCReport.xlsx');
  }
  
  const renderReport = () => (
    <div
      className={styles.formGroup}

    >
      <div
        //  className={styles.customeTable}
        className={styles.col2} style={{
          width: "100%",
          height: "100%",
          marginTop: "10px"
        }}
      >
        <Grid
        container
        spacing={0}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
      {SUFlag ? (
          <>
        <Grid item md={2} lg={2} sm={12}>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            required={true}         
            markIfUnselected={highlightMandatoryFields}
            resetAllVisitedFields={resetAllVisitedFields}
            style={{
              marginLeft: "10px",
              marginRight: "11px",
            }}
                value={myState.UserRole}               
                defaultValue=""
                onClick={(e) => handleUserRoleDetails(e.target.value)}
                className={styles.radiobtn}
          >     
            <FormControlLabel
              value="S"
              name="status"
              control={<Radio size="small" />}
              label="Supervisor"
              style={{ color: "black" }}
              className={styles.radiobtn}
            />
          </RadioGroup>
        </Grid>

        </>
        ):(
          "")}

        {IndFlag ? (
          <>
        <Grid item md={2} lg={2} sm={12}>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            required={true}         
            markIfUnselected={highlightMandatoryFields}
            resetAllVisitedFields={resetAllVisitedFields}
            style={{
              marginLeft: "10px",
              marginRight: "11px",
            }}
                value={myState.UserRole}             
                defaultValue=""
                onClick={(e) => handleUserRoleDetails(e.target.value)}
                className={styles.radiobtn}
          >
            <FormControlLabel
              value="U"
              name="status"
              control={<Radio size="small" />}
              label="Individual"
              style={{ color: "black" }}
              className={styles.radiobtn}
            />
          </RadioGroup>
        </Grid>

        </>
        ):(
          "")}

      {MangerFlag ? (
          <>
        <Grid item md={2} lg={2} sm={12}>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            required={true}      
            markIfUnselected={highlightMandatoryFields}
            resetAllVisitedFields={resetAllVisitedFields}
            style={{
              marginLeft: "10px",
              marginRight: "11px",
            }}
                value={myState.UserRole}
                // onChange={(e) => setProDetails(e.target.value)}
                defaultValue=""
                onClick={(e) => handleUserRoleDetails(e.target.value)}
                className={styles.radiobtn} 
          >
           
            <FormControlLabel
              value="M"
              name="status"
              control={<Radio size="small" />}
              label="Manager"
              style={{ color: "black" }}
              className={styles.radiobtn}
            />

          </RadioGroup>
        </Grid>
        </>
        ): (
          "")}

     {DSFlag ? (
          <>
        <Grid item md={3} lg={3} sm={12}>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            required={true}  
            markIfUnselected={highlightMandatoryFields}
            resetAllVisitedFields={resetAllVisitedFields}
            style={{
              marginLeft: "10px",
              marginRight: "11px",
            }}
                value={myState.UserRole}
                defaultValue=""
                onClick={(e) => handleUserRoleDetails(e.target.value)}
                className={styles.radiobtn}
          >
           

            <FormControlLabel
              value="DS"
              name="status"
              control={<Radio size="small" />}
              label="Departmental SPOC"
              style={{ color: "black" }}
              className={styles.radiobtn}
            />
          </RadioGroup>
        </Grid>

        </>
        ):(
          "")}

        {SAFlag ? (
          <>
        <Grid item md={2} lg={2} sm={12}>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            markIfUnselected={highlightMandatoryFields}
            resetAllVisitedFields={resetAllVisitedFields}
            style={{
              marginLeft: "10px",
              marginRight: "11px",
              alignItems: "center",
              float: "center",}}
           
               value={myState.UserRole}
                // onChange={(e) => setProDetails(e.target.value)}
                defaultValue=""
                onClick={(e) => handleUserRoleDetails(e.target.value)}
                className={styles.radiobtn}
          >
            
            <FormControlLabel
              value="SA"
              name="status"
              control={<Radio size="small" />}
              label=" Super Admin"
              style={{ color: "black" }}
              className={styles.radiobtn}
            />
          </RadioGroup>
        </Grid>
        </>
        ): (
          "")}
        
        </Grid>
     {myState.UserRole &&
     <div className={styles.formGroup}>
   <div
      //  className={styles.customeTable}
      className={styles.col2} style={{
        width: "100%",
        height: "100%",
        marginTop: "10px"
      }}
    >
      <>
      {allTableData?.length > 0 && 
          <ReportTable columns={baseDefaultColumns} data={allTableData} height={HEIGHT} fileName={FILENAME} />
      }
         
    </>
    </div>
    </div>}

        
      </div>

    </div>)    
const renderReport1 = () => (
  <div
    className={styles.formGroup}

  >
    <div
      className={styles.col2} style={{
        width: "100%",
        height: "100%",
        marginTop: "10px"
      }}
    >
      
          <>
          {allTableData?.length > 0 && 
           <ReportTable columns={baseDefaultColumns} data={allTableData} height='320px' fileName={FILENAME}/>
          }   
      </>
      
    </div>

  </div>)

  return (
    <>
      <div className={clsx(styles.scrollContainer, styles.formContainer)}>


        {/* <CustomFormGroup header='SPOC Form' body={renderOther()} /> */}
        {
          tableData.length == 0 && userList.length > 1 &&
          <CustomFormGroup header='SPOC Report' body={renderReport()} />

        }
        {/* {renderReportTable()} */}
        {
          tableData.length == 0 && userList.length == 1 &&
          <CustomFormGroup header='SPOC Report' body={renderReport1()} />

        }
        {
          loading ? (
            <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
                 <Truckloading />
              </div>):""
        }

      </div>
      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        resetFields={resetFields}
      />

    </>
  )
}


function ResetModal2({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Do you want to delete ?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleCase}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}
function ResetModal1({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Do you want to delete ?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleCase}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}

function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: '18px', width: '18px' }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>
            Are you sure you want to reset the filters?
          </span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(
              styles.actionButton,
              styles.transparentButton
            )}
            onClick={handleClose}
          >Cancel</Button>
          <Button
            className={clsx(
              styles.actionButton,
              styles.primaryActionButton,
            )}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose()
              resetFields()
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}

SpocForm.propTypes = {
  redirectToProcessPage: PropTypes.func
}

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired
}
ResetModal1.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}
ResetModal2.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
const mapDispatchToProps = (dispatch) => ({

  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
SpocForm.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(SpocForm);


export default withAllowedOperationsProvider(
  App,
  RESOURCE_TYPE.PPAP
);